
// LoadingScreen.js - Enhanced with a more attractive and smoother loading animation
import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-white to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-32 w-32 rounded-full border-t-4 border-b-4 border-blue-600 animate-spin"></div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-24 w-24 rounded-full border-r-4 border-l-4 border-indigo-500 animate-spin animate-ping"></div>
        </div>
        <div className="h-16 w-16 rounded-full bg-blue-600/20 animate-pulse"></div>
      </div>
      <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mt-8 animate-pulse">Loading<span className="animate-bounce">.</span><span className="animate-bounce delay-100">.</span><span className="animate-bounce delay-200">.</span></h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">Please wait while we prepare your content</p>
    </div>
  );
};

export default LoadingScreen;